export const meta = {
  title: '隐私政策',
  description: '了解配装本地存储、分享链接、分析脚本与反馈方式。',
  updated_at: '2026-10-08',
};

## 配装本地存储

配装选择使用浏览器 localStorage，键名为 `control-resonant-build-v1`。重置会删除保存记录；无需账号或上传游戏存档。

## 分享链接

链接参数包含所选技能，拿到链接的人可以查看这些选择。地址可能留在浏览器历史、托管日志或分析记录中，请勿加入个人信息。

## 访问分析与会话洞察

明确配置后，Google Analytics 4 用于访问分析，Microsoft Clarity 用于交互分析与会话回放。服务商可能使用 Cookie，并按各自政策处理设备、网络和交互信息。本站发送拒绝存储的信号，请求使用有限的无 Cookie 分析模式。实际 Cookie 行为还取决于 Clarity 项目配置；项目未要求同意前，服务商仍可能设置 Cookie。Clarity 默认遮罩敏感字段；请勿在分享链接中输入隐私信息。本站不会把本地配装上传为账号档案。

## 偏好与控制

主题和配装偏好可保存在本地，语言与来源归因可能使用 Cookie。浏览器隐私设置可以限制分析和存储，公开攻略仍可阅读。清除站点数据或使用重置可移除配装记录。

## 外部链接与托管

来源链接指向独立网站，其隐私规则由各网站制定。Cloudflare 可能保留请求与安全日志。

## 联系我们

隐私问题请发送至 [support@controlresonanttools.online](mailto:support@controlresonanttools.online)。
